import {
	loginStart,
	loginSuccess,
	refreshTokenStart,
	loginFailure,
	logout,
	refreshTokenFailure,
	getSyncUserDataStart,
	getSyncUserDataSuccess,
	getSyncUserDataFailure,
} from '../reducers/user';

import { axiosPublic, axiosPrivate } from "../../api/axios";
import { refreshSession } from "../../api/authSession";
import { persistor } from '../store';
import { disconnectSocket } from '../../services/socket';
import { getPresenceSessionId, rotatePresenceSessionId } from '../../services/presenceSession';

export const loginUser = ({ email, password }) => async (dispatch) => {
	try {
		dispatch(loginStart());
		const response = await axiosPublic.post(`/auth/login`,
			{
				email,
				password
			});
		
		if (response.status === 200) {
			rotatePresenceSessionId();
			dispatch(loginSuccess(response.data));
			return {
				status: response.status || null,
				message: `Bienvenido ${response.data.user?.firstName} ${response.data.user?.lastName}`
			};
		}
	} catch (error) {
		dispatch(loginFailure());
		console.log(error)
		return {
			status: error.response?.status || null,
			message: error.response?.data?.message || 'Error al iniciar sesión'
		};
	}
};

export const signUp = ({ name, apellido, email, password }) => async (dispatch) => {
	try {

		const response = await axiosPublic.post(`/auth/signup`,
			{
				name,
				apellido,
				email,
				password
			});
		// Verifica si la respuesta es exitosa
		if (response.status === 200 && response.data.success) {
			dispatch(loginSuccess(response.data));
		} else {
			// En caso de respuesta no exitosa, muestra el mensaje de error
			dispatch(loginFailure());
		}
	} catch (error) {
		// En caso de error en la llamada al servidor, muestra el mensaje de error
		dispatch(loginFailure());
		return {
			status: error.response?.status || null,
			message: error.response?.data?.message || 'Error al registrarse'
		};
	}
};

export const checkRefreshToken = () => async (dispatch, getState) => {
	dispatch(refreshTokenStart());
	const { refreshToken } = getState().user;
	try {
		const response = await refreshSession();
		return response.status;
	} catch (error) {
		dispatch(refreshTokenFailure());
		dispatch(logout());
		await persistor.purge();
		return null;
	}
};

export const logoutUser = () => async (dispatch) => {
	const sessionId = getPresenceSessionId();
	try {
		await axiosPrivate.post(`/auth/logout`, { sessionId });
	} catch (error) {
		// console.error('Error al cerrar sesión:', error);
	} finally {
		disconnectSocket();
		rotatePresenceSessionId();
		dispatch(logout());
		await persistor.purge();
	}
};

export const forgotPasswordEmail = (email) => async (dispatch) => {
	try {
		const response = await axiosPublic.post(`/auth/forgot-password-email`,
			{
				email
			});
		if (response.status === 200) {
			return {
				status: response.status || null,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response?.status || null,
			message: error.response?.data?.message || 'Error al enviar correo'
		};
	}
};

export const updatedPassword = ({ email, password }) => async (dispatch) => {
	try {
		const response = await axiosPublic.put(`/auth/update-password`,
			{
				email,
				password
			});
		return {
			status: response.status || null,
			message: response.data.message
		};
	} catch (error) {
		return {
			status: error.response?.status || null,
			message: error.response?.data?.message || 'Error al actualizar contraseña'
		};
	}
};

export const getSyncUserData = (idUser) => async (dispatch) => {
	dispatch(getSyncUserDataStart());
	try {

		const response = await axiosPublic.get(`/users/getUserById/${idUser}`);
		dispatch(getSyncUserDataSuccess(response.data))

	} catch (error) {
		dispatch(getSyncUserDataFailure());
	}
};
